import { useState, useEffect } from 'react';

// ✅ Usa lo stesso URL che hai in strapiService.js
const API_URL = 'https://cms-finday-v2.onrender.com/api';

export const useEventInterest = (eventId) => {
  const [isInterested, setIsInterested] = useState(false);
  const [interestCount, setInterestCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // Controlla se l'utente ha già espresso interesse per questo evento
  useEffect(() => {
    const checkUserInterest = () => {
      const interestedEvents = JSON.parse(localStorage.getItem('interestedEvents') || '[]');
      setIsInterested(interestedEvents.includes(eventId));
    };

    if (eventId) {
      checkUserInterest();
      fetchInterestCount();
    }
  }, [eventId]);

  // Recupera il conteggio degli interessati da Strapi
  const fetchInterestCount = async () => {
    try {
      const response = await fetch(`${API_URL}/events/${eventId}?fields=interestCount`);
      if (response.ok) {
        const data = await response.json();
        
        // ✅ CORREZIONE: Controllo defensivo per evitare l'errore
        let count = 0;
        
        // Prova diverse strutture possibili della risposta
        if (data?.data?.attributes?.interestCount !== undefined) {
          count = data.data.attributes.interestCount;
        } else if (data?.data?.interestCount !== undefined) {
          count = data.data.interestCount;
        } else if (data?.interestCount !== undefined) {
          count = data.interestCount;
        }
        
        setInterestCount(count || 0);
        
        // ✅ DEBUG: Aggiungi questo log per vedere la struttura effettiva
        console.log('Struttura risposta API interestCount:', data);
        
      } else {
        console.warn('Risposta API non ok:', response.status);
        setInterestCount(0);
      }
    } catch (error) {
      console.error('Errore nel recuperare il conteggio degli interessati:', error);
      setInterestCount(0); // ✅ Imposta un valore di fallback
    }
  };

  // Gestisce il click sul pulsante "Mi interessa"
  const handleInterestToggle = async () => {
    try {
      setIsLoading(true);
      
      const response = await fetch(`${API_URL}/events/${eventId}/interest`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: isInterested ? 'decrement' : 'increment'
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      // Aggiorna lo stato locale
      setIsInterested(!isInterested);
      
      // ✅ Aggiorna anche il localStorage
      const interestedEvents = JSON.parse(localStorage.getItem('interestedEvents') || '[]');
      if (isInterested) {
        // Rimuovi dall'array
        const updatedEvents = interestedEvents.filter(id => id !== eventId);
        localStorage.setItem('interestedEvents', JSON.stringify(updatedEvents));
      } else {
        // Aggiungi all'array
        interestedEvents.push(eventId);
        localStorage.setItem('interestedEvents', JSON.stringify(interestedEvents));
      }
      
      // ✅ Aggiorna il conteggio se disponibile nella risposta
      if (result?.interestCount !== undefined) {
        setInterestCount(result.interestCount);
      } else {
        // Ricarica il conteggio se non è nella risposta
        fetchInterestCount();
      }
      
      console.log('Nuovo conteggio interesse:', result.interestCount || 'non disponibile');
      
    } catch (error) {
      console.error('Errore nell\'aggiornamento dell\'interesse:', error);
      throw new Error('Errore nell\'aggiornamento');
    } finally {
      setIsLoading(false);
    }
  };
 
  return {
    isInterested,
    interestCount,
    isLoading,
    handleInterestToggle
  };
};
